export class SPNFTQuestionnaire {
    constructor(
        public OfferID?: Number,
        public Firstname?: String,
        public Lastname?: String,
        public CompanyName?: String,
        public JMBG?: String,
        public DateOfBirth?: String,
        public PlaceOfBirth?: String,
        public Address?: String,
        public PostalCode?: String,
        public Settlement?: String,
        public Citizenship?: String,
        public LegalRepresentativeFirtsname?: String,
        public LegalRepresentativeLastname?: String,
        public LegalRepresentativeJMBG?: String,
        public TaxID?: String,
        public CompanyID?: String,
        public PersonalDocumentType?: String,
        public PersonalDocumentNumber?: String,
        public PersonalDocumentIssuedDate?: String,
        public PersonalDocumentExpirationDate?: String,
        public PersonalDocumentIssuedPlace?: String,
        public IsPoliticianOrCloseAssociate?: Boolean,
        public InOffice?: String,
        public RemarkIfYes?: String,
        public ClientAppliesThroughIntermediary?: Boolean,
        public IntermediaryType?: Number,
        public IntermediaryFirstname?: String,
        public IntermediaryLastname?: String,
        public IntermediaryJMBG?: String,
        public IntermediaryDateOfBirth?: String,
        public IntermediaryPlaceOfBirth?: String,
        public IntermediaryAddress?: String,
        public IntermediaryPostalCode?: String,
        public IntermediarySettlement?: String,
        public IntermediaryPersonalDocumentType?: String,
        public IntermediaryPersonalDocumentNumber?: String,
        public IntermediaryPersonalDocumentIssuedDate?: String,
        public IntermediaryPersonalDocumentIssuedPlace?: String,
        public BusinessRelationshipClientPurpose?: Number,
        public BusinessRelationshipClientPurposeOther?: String,
        public PropertyOrigin?: Number,
        public PropertyOriginOther?: String) { }
}